const notifeeWeb = {
  requestPermission: async () => {},
  displayNotification: async () => {},
  setBadgeCount: async () => {},
};

export default notifeeWeb;
